<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiExclamation } from "@mdi/js";
export default {
  name: "MdiEye",
  data() {
    return {
      svgPath: mdiExclamation,
    };
  },
};
</script>
